import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clip-rule="evenodd"
    d="M9.13629 13.7096L7.72133 12.2954L3.01172 17.0025L7.72133 21.7096L9.13629 20.2954L6.84218 18.0025H21.5222V16.0025H6.84218L9.13629 13.7096ZM15.8871 3.70886L17.3021 2.29465L22.0117 7.00175L17.3021 11.7089L15.8871 10.2946L18.1812 8.00175L3.50119 8.00175V6.00175L18.1812 6.00175L15.8871 3.70886Z"
    fill="#21201F"
    fill-rule="evenodd"
  />,
  'ArrowsSwitch',
)
